type SyncErrorContext = {
  isOnline?: boolean | null;
};

/** Mensaje corto para el empleado en pantalla. */
export function formatSyncErrorForUser(
  raw: string | null | undefined,
  context: SyncErrorContext = {}
): string {
  const err = (raw ?? '').trim();
  if (!err) return 'No se pudo completar la operación.';

  const lower = err.toLowerCase();
  if (lower.includes('web_no_local_queue')) {
    return 'No se pudo guardar en el servidor. Cerrá el navegador del todo, volvé a entrar a app.vuelto.ar y reintentá.';
  }
  if (
    context.isOnline === false ||
    lower.includes('failed to fetch') ||
    lower.includes('network request failed') ||
    lower.includes('network error')
  ) {
    return 'Sin conexión. Se reintentará cuando vuelva internet.';
  }
  if (
    lower.includes('not authorized') ||
    lower.includes('permission denied') ||
    lower.includes('module_permission_denied') ||
    lower.includes('permiso')
  ) {
    return 'No tenés permisos para esta acción.';
  }
  if (lower.includes('timeout') || lower.includes('timed out')) {
    return 'La operación tardó demasiado. Reintentá en unos segundos.';
  }

  const firstLine = err.split('\n')[0]?.split('|')[0]?.trim() ?? err;
  if (firstLine.length > 140) return `${firstLine.slice(0, 137)}…`;
  return firstLine;
}

/** Detalle acotado para Soporte (sin stacks ni URLs de desarrollo). */
export function formatSyncErrorForSupport(
  raw: string | null | undefined,
  context: SyncErrorContext = {}
): string {
  const userLine = formatSyncErrorForUser(raw, context);
  const err = (raw ?? '').trim();
  if (!err) return userLine;

  const lower = err.toLowerCase();
  if (
    context.isOnline === false ||
    lower.includes('failed to fetch') ||
    lower.includes('network request failed')
  ) {
    return userLine;
  }

  const meaningful = err
    .split('\n')
    .map((line) => line.trim())
    .filter(
      (line) =>
        line.length > 0 &&
        !line.startsWith('at ') &&
        !line.includes('localhost:') &&
        !line.includes('.bundle?')
    );

  const compact = meaningful.slice(0, 2).join(' | ');
  if (!compact) return userLine;
  if (compact.length > 240) return `${compact.slice(0, 237)}…`;
  return compact;
}
